// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Botswana from '../_raw/flag/icon_flag_botswana.png';

export default () => <img src={Botswana} alt="Botswana" />;
